import { I18nComponente } from "@/types/gerais"

export const OHorasi18n: I18nComponente = {
  "pt-BR": {
    e: "e"
  },
  "es-CO": {
    e: "y"
  }
}
